export default __webpack_public_path__ + "static/usability-testing-cover-57b02b32734cc83404ded987518177ed.png";